import { PropsWithChildren } from 'react';
import cn from 'classnames';
import { baseCellClassname } from '@lp/features/Scheduler/constants';

type DayCellProps = PropsWithChildren<{
  active: boolean;
  highlight?: boolean;
  hasPrev?: boolean;
  hasNext?: boolean;
}>;

export const DayCell = ({ active, highlight, hasPrev, hasNext, children }: DayCellProps) => {
  return (
    <td
      className={cn('static py-1.5 px-3 min-w-[158px] h-[57px]', baseCellClassname, {
        'bg-base-70': active,
        'animate-[cell-highlight_.5s_ease-in-out_3_1s]': highlight,
        'ps-0': hasPrev,
        'pe-0': hasNext,
      })}
    >
      {children}
    </td>
  );
};
